// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/dist/cjs.js!../../../../node_modules/sass-loader/dist/cjs.js!../../../shared/styles/utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C8mqyzt3x{}._6icklOhBx{width:100%}", "",{"version":3,"sources":["webpack://client/management/apps/custom-suggestion-input/custom-suggestion-input.scss"],"names":[],"mappings":"AAAA,WACE,CAGF,YACE,UAAA","sourcesContent":[".label {\n  composes: form-label from \"~@css/utils.scss\";\n}\n\n.select {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "C8mqyzt3x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["form-label"] + "",
	"select": "_6icklOhBx"
};
export default ___CSS_LOADER_EXPORT___;
